var map = {
	"./laboratory_logo": 30,
	"./laboratory_logo.png": 30,
	"./pharmacien": 31,
	"./pharmacien.png": 31,
	"./pharmacy_placeholder": 32,
	"./pharmacy_placeholder.png": 32,
	"./tizymap": 33,
	"./tizymap.svg": 33,
	"./tizymapold": 34,
	"./tizymapold.svg": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;